import { render } from "./Create.vue?vue&type=template&id=0c5c3887"
import script from "./Create.vue?vue&type=script&lang=ts"
export * from "./Create.vue?vue&type=script&lang=ts"
script.render = render

export default script